import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';

import Button from 'components/field/Button';
import CopyComponent from 'components/field/CopyComponent';
import FormItem from 'components/form/FormItem';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { USERS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

export default NiceModal.create(() => {
	const modal = useModal();
	const [isLoading, setIsLoading] = useState(false);
	const axiosPrivate = useAxiosPrivate();
	const { showError } = useAlert();
	const [accessLink, setAccessLink] = useState('');

	useEffect(() => {
		generateAccessLink();
	}, []);

	const generateAccessLink = () => {
		setIsLoading(true);
		axiosPrivate
			.post(USERS.CREATE_SUPPORT_ACCESS_LINK)
			.then((response) => {
				const { data, status } = response;

				if (status === 200) {
					AppLogger.info(data);
					setAccessLink(data.supportAccessLink);
				} else {
					AppLogger.error(response);
				}
			})
			.catch((error) => {
				AppLogger.error(error);
				showError();
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<Modal maxWidth="small">
			<ModalTitle>
				<Typography variant="p1">support.createPermissionTitle</Typography>
			</ModalTitle>

			<ModalContent style={{ width: '100%' }}>
				<FormItem label="pageLink" isLoading={isLoading}>
					<CopyComponent value={accessLink} />
				</FormItem>
			</ModalContent>
			<ModalActions>
				<Button label="close" variant="outline" onClick={modal.remove} />
			</ModalActions>
		</Modal>
	);
});
